export const NAVIGATION_CONSTANTS = {
  HOME_PAGE: '/',
  ACCOUNT_PAGE: '/account',
  ACCOUNT_COMMUNICATION_PREFERENCES_PAGE: '/account/communication',
  ACCOUNT_DELIVERY_ADDRESSES_PAGE: '/account/delivery-addresses',
  ACCOUNT_MANAGE_EMAIL_PAGE: '/account/manage-email',
  ACCOUNT_ONLINE_SHOPPING_PREFERENCES_PAGE:
    '/account/online-shopping-preferences',
  ACCOUNT_ORDERS_PAGE: '/account/orders',
  ACCOUNT_ORDERS_INVOICE_PAGE: '/account/orders/invoice',
  ACCOUNT_PERSONAL_DETAILS_PAGE: '/account/personal-details',
  ACCOUNT_SUBSCRIPTIONS_PAGE: '/account/subscriptions',
  BUY_AGAIN_PAGE: '/lists/buy-again',
  CART_PAGE: '/cart',
  CHECKOUT_PAGE: '/checkout',
  CHECKOUT_PAGES_ROOT: 'checkout',
  CHECKOUT_ORDER_CONFIRMATION_SUBROUTE: 'confirmation',
  CHECKOUT_CONFIRMATION_PAGE: '/checkout/confirmation',
  EVERYDAY_REWARDS_PAGE: '/everyday-rewards',
  EVERYDAY_REWARDS_DASHBOARD_PAGE: '/everyday-rewards/dashboard',
  HAVE_YOU_FORGOTTEN_PAGE: '/checkout/have-you-forgotten',
  LIST_PAGE: '/lists',
  LOGIN_PAGE: '/auth/login',
  LOGOUT_PAGE: '/auth/logout',
  NATIVE_APP_CALLBACK_PAGE: '/checkout/payment/native-app-callback',
  PAST_SHOPS_PAGE: '/lists/past-shops',
  PAYMENT_PAGE: '/checkout/payment',
  PRODUCT_DETAILS_PAGE: '/shop/product-details',
  PRODUCT_GROUP_PAGE: '/shop/product-group',
  RECIPE_TAG: '/recipe-tag',
  RECIPE: '/recipe',
  RECIPES: '/recipes',
  RECIPES_SAVED: '/recipes/saved',
  REVIEW_ORDER_PAGE: '/checkout/review-order',
  SEARCH_PRODUCTS_PAGE: '/shop/search/products',
  SEARCH_RECIPES_PAGE: '/shop/search/recipes',
  SHOP_BROWSE_PAGE: '/shop/browse',
  SPECIALS_OFFERS: '/specials-offers',
  SPECIALS_OFFERS_BOOST_PAGE: '/specials-offers/boosts',
  MAILER_PAGE: '/specials-offers/mailer',
  MEMBER_PRICES: '/specials-offers/member-prices',
  LOW_PRICE: '/shop/low-price',
  OFFER_GROUP_PAGE: '/shop/offer-group',
  VIEW_ORDERS_PAGE: '/view-orders',
  FAQS: '/help/faqs',
  CONTACT_US: '/help/contact',
  DELIVERY_SUBSCRIPTION_URL: '/services/online-shopping/delivery-subscription',
  DIETARY_LIFESTYLE_FILTERS_PAGE: '/discover/guides/dietary-lifestyle-filters',
};

export const PROD_BASE_URL = 'https://www.woolworths.co.nz';

export const TRADER_NAVIGATION_CONSTANTS = {
  FAQS: '/shop/content/faqs',
  OLIVE: '/about-us/contact-us',
  CUSTOMER_CARE: '/about-us/contact-us#contactUs-stillStuck',
  ONLINE_SHOPPING_TNC:
    '/info/terms-and-conditions/online-shopping-website-and-app',
  PRIVACY_POLICY: '/help/policies/privacy-policy',
};

export const EDR_BASE_URL =
  process.env.NEXT_PUBLIC_REWARDS_URL || 'https://www.everydayrewards.co.nz';

export const EDR_ROUTES = {
  CARD: `${EDR_BASE_URL}/account/card`,
  REWARDS_POINTS: `${EDR_BASE_URL}/account/points-and-activity`,
} as const;
